import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Course from "./pages/Course/Course";
import Home from "./pages/Home/Home";
import Projects from "./pages/Projects/Projects";
import ServicePage from "./pages/Service/ServicePage";
import MainNav from "./shared/MainNav/MainNav";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RefundPolicy from "./components/RefundPolicy/RefundPolicy";
import Refund from "./pages/Refund/Refund";
import Terms from "./pages/Terms/Terms";
import Privacy from "./pages/Privacy/Privacy";
import ProjectDetailsPage from "./pages/ProjectDetailsPage/ProjectDetailsPage";
import CourseDetailPage from "./pages/CourseDetailPage/CourseDetailPage";
import appCss from "./App.module.css";

function App() {
  return (
    <div className={appCss.responsive}>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/courses" element={<Course />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/services" element={<ServicePage />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/projectDetails/:id" element={<ProjectDetailsPage />} />
          <Route
            path="/courseDetails/:id/:name"
            element={<CourseDetailPage />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
